module.exports = __webpack_public_path__ + "img/no-data.012d4ad9.png";